import React from 'react'

interface Pre extends React.HTMLProps<HTMLPreElement> {
  isHeader?: boolean
  node?: any
}

const Pre: React.FC<Pre> = ({ children, isHeader, node, ...props }) => {
  return (
    <div className="overflow-x-auto">
      <pre
        className="text-primary-900 dark:text-primary-200 bg-primary-200 dark:bg-default-dark"
        {...props}
      >
        {children}
      </pre>
    </div>
  )
}

export default Pre
